<template>
	<div class="live-place1">
		<div class="dateList" v-if="color">
			<div class="item" v-for="(item, index) in scheduleDate" :key="item">
				<a href="javascript:void(0)" @click="switchDate(item)" :class="item == active ? 'active' : ''"
					:style="{ backgroundColor: (item == active ? color : '') }">
					{{ item }}
					<p>{{ weekdays[index] }}</p>
				</a>
			</div>
		</div>
		<div class="dateList" v-else>
			<div class="item" v-for="(item, i) in scheduleDate" :key="item">
				<a href="javascript:void(0)" @click="switchDate(item)" :class="item == active ? 'active' : ''">
					{{ item }}
					<p>{{ weekdays[i] }}</p>
				</a>
			</div>
		</div>
		<div class="live-list">
			<div class="live-item" v-for="(item, index) in scheduleList" :key="index"
				@click="switchMeetingPlace(item.id, index)" :style="{ 'clear': (index % 2 == 0 ? 'both' : '') }">
				<div class="image">
					<img v-if="item.banner_type == 1 && item.banner" :src="item.banner" alt="" class="bgCover"
						onerror="common.imgError(2,event)">
					<div class="bgCover3" v-if="item.banner_type == 2 && item.banner">
						<img :src="item.banner" alt="">
						<ul>
							<p :style="{ 'color': item.schedule_font_color_hex ? item.schedule_font_color_hex : '#fff' }">{{
								item.time }}{{ item.name }}{{ item.hall_name ? '(' + item.hall_name + ')' : '' }}</p>
							<li v-for="ct in item.chapters" :key="ct.id"
								:style="{ 'color': item.schedule_font_color_hex ? item.schedule_font_color_hex : '#fff' }">
								<span
									:style="{ 'background-color': item.schedule_font_color_hex ? item.schedule_font_color_hex : '#fff' }"></span>
								{{ ct.name }}
							</li>
						</ul>
					</div>
					<div class="small-icon">
						<img v-if="item.live_status == 2" src="../../../../assets/images/System/record_icon.png">
						<img v-else src="../../../../assets/images/System/live_icon.png">
					</div>
				</div>
				<h1 class="line-clamp-2">{{ item.daily_preview_title ? item.daily_preview_title : item.name }}{{
					item.hall_name ? '（' + item.hall_name + '）' : '' }}</h1>
				<p class="time">
					<van-icon name="clock-o" />
					<span>{{ formatTime(item.start_at) }}</span>
				</p>
			</div>
		</div>

	</div>
</template>
<script>
export default {
	props: ['scheduleDate', "weekdays", 'meetingSchedule', 'color'],
	data() {
		return {
			active: 0,
			scheduleList: [],
			meeting_id: this.$route.query.meeting_id ? this.$route.query.meeting_id : this.$route.query.MT_id,

		}
	},
	mounted() {
		let date_string = localStorage.getItem("switch_meeting_" + this.meeting_id);
		if (date_string && Object.keys(this.meetingSchedule).includes(date_string)) {
			this.switchDate(date_string)
		}
		else {
			let today = this.getToday();
			if (this.scheduleDate.indexOf(today) > -1) {
				let index = this.scheduleDate.indexOf(today);
				this.switchDate(this.scheduleDate[index]);
			}
			else {
				this.switchDate(this.scheduleDate[0]);
			}

		}
	},
	watch: {
		'$route'(to, from) {
			this.$router.go(0);
		},

	},
	methods: {
		//切换会场
		switchMeetingPlace(id, index) {
			localStorage.setItem("switch_meeting_" + this.meeting_id, this.active)
			this.$router.push({
				path: '/vascularNews/meeting/liveDetail',
				query: {
					id: id,
					meeting_id: this.meeting_id
				}
			})
		},
		getToday() {
			let date = new Date();
			let month = date.getMonth() + 1;
			let day = date.getDate();
			let str = month + "月" + day + "日";
			return str;
		},
		//切换日期
		switchDate(date) {
			this.active = date;
			setTimeout(() => {
				this.scheduleList = this.meetingSchedule[date];
			}, 500)
		},
		formatTime(time) {
			if (time != null) {
				return time.slice(0, 16);
			}
			return '';
		}
	}
}
</script>
<style lang="scss">
.live-place1 {
	margin: 0 10px;

	.dateList {
		padding-top: 15px;
		display: flex;
		flex-wrap: wrap;

		.item {
			width: 25%;
			margin-bottom: 5px;
		}

		a {
			background: #ececec;
			display: block;
			border-radius: 3px;
			font-size: 13px;
			color: $color-gray;
			margin: 0 5px;
			text-align: center;
			padding: 5px 0;
			// padding: 4px 10px;

		}

		a.active {
			color: white;
			background: $color-main;
		}
	}
	.live-list{
		// display: flex;
		// flex-wrap: wrap;
		// padding: 0 5px;
	}
	.live-item {
		width: 46%;
		float: left;
		border: 1px solid rgba(225, 225, 225, 1);
		margin: 5px 2%;
		// margin-bottom: 10px;
		border-radius: 5px;

		h1 {
			height: 30px;
			line-height: 15px;
			padding: 0 12px;
			margin: 10px 0 5px;
			font-size: 13px;
			color: #1a1a1a;
			font-weight: normal;
		}

		.image {
			width: 100%;
			position: relative;

			.bgCover {
				border-radius: 5px 5px 0 0;
				width: 100%;
				position: relative;
			}

			.small-icon {
				position: absolute;
				bottom: 0;
				right: 0;

				img {
					width: 45px;
					height: 30px;

				}
			}


			.bgCover3 {
				border-radius: 5px 5px 0 0;
				width: 100%;
				position: relative;
				overflow: hidden;
				// height: 130px;

				img {
					min-height: 110px;
					background-color: #fff;
					width: 100%;

				}

				ul {
					position: absolute;
					top: 10px;
					bottom: 10px;
					padding: 10px;
					overflow: hidden;

					p {
						font-size: 10px;
						line-height: 15px;
					}

					li {
						font-size: 8px;
						line-height: 14px;
						display: flex;
						align-items: center;
					}

					span {
						display: inline-block;
						width: 5px;
						height: 5px;
						background: #000;
						border-radius: 50%;
						margin-right: 5px;
					}
				}
			}
		}

		.time {
			display: flex;
			align-items: center;
			margin: 0 auto 5px;
			padding: 0 12px;
			color: $color-gray;
			font-size: 12px;

			span {
				margin-left: 5px;
				font-size: 0.3rem;
			}
		}
	}
}

@media screen and (min-width:800px) {
	.bgCover3 {
		ul {
			padding: 6% !important;
		}

	}
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/components/Meeting/MeetingPlace.vue